import { presignIncidenceRequestAttachmentDownload } from 'api/incidence-request.api';

type DownloadableIncidenceRequestAttachment = {
  name: string;
  url?: string;
  s3Key?: string;
};

export const canDownloadUrl = (url?: string) =>
  Boolean(url && /^https?:\/\//i.test(url.trim()));

const triggerBrowserDownload = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadIncidenceRequestAttachment = async ({
  requestId,
  attachment,
}: {
  requestId: string;
  attachment: DownloadableIncidenceRequestAttachment;
}) => {
  if (canDownloadUrl(attachment.url)) {
    triggerBrowserDownload(attachment.url!, attachment.name);
    return;
  }

  if (!attachment.s3Key) {
    throw new Error(
      'El adjunto no cuenta con una referencia válida para descargarse.'
    );
  }

  const { data } = await presignIncidenceRequestAttachmentDownload(requestId, {
    s3Key: attachment.s3Key,
  });

  if (!data.downloadUrl) {
    throw new Error('No fue posible generar la descarga del adjunto.');
  }

  triggerBrowserDownload(data.downloadUrl, data.attachment.name);
};
